import { createLazyService, createScope, createService } from '@tencent/tiny-ioc';
import { ILocalEditContext } from './interfaces/local-edit-context.interface';
import { ILocalEditDataConverter } from './interfaces/local-edit-data-converter.interface';
import { ILocalEditService } from './interfaces/local-edit-service.interface';
import { SlideDataServices } from '../../../core/slide-data-services.core';
import { ILocalEditEvents } from './interfaces/local-edit-events.interface';
import { ILocalEditManager } from './interfaces/local-edit-manager.interface';
import { IConvertErrorModal } from './interfaces/convert-error-modal.interface';
import { IDocVerifierManager } from '@src/slide/domain/slide-app/core/interfaces/doc-verifier-manager.interface';

export const LocalEditServices = createScope(() => {
    const UI = createScope(() => {
        const ConvertErrorModal = createLazyService<IConvertErrorModal>().dependsOn([
            SlideDataServices.UI.Modal,
            SlideDataServices.Infra.Mqq,
        ]);

        return {
            ConvertErrorModal,
        };
    });

    // 本地编辑上下文信息
    const LocalEditContext = createService<ILocalEditContext>().dependsOn([]);

    // 本地编辑事件
    const LocalEditEvents = createService<ILocalEditEvents>().dependsOn([]);

    // 文档密码校验
    const DocVerifierManager = createService<IDocVerifierManager>().dependsOn([
        SlideDataServices.Infra.Logger,
        LocalEditContext,
        LocalEditEvents,
        SlideDataServices.Infra.Mqq,
    ]);

    // 本地编辑数据转换工具
    const LocalEditDataConverter = createService<ILocalEditDataConverter>().dependsOn([
        DocVerifierManager,
    ]);

    // 本地编辑UI提示管理器
    const LocalEditNoticeManager = createService<{}>().dependsOn([
        SlideDataServices.Infra.Logger,
        LocalEditEvents,
    ]);

    // 本地编辑数据上报器
    const LocalEditReporter = createService<{}>().dependsOn([
        SlideDataServices.Infra.Logger,
        LocalEditContext,
        LocalEditEvents,
        SlideDataServices.States.SlideCountState,
        SlideDataServices.EventManager,
    ]);

    // 本地编辑服务
    const LocalEditService = createService<ILocalEditService>().dependsOn([
        SlideDataServices.Infra.Logger,
        LocalEditContext,
        LocalEditEvents,
        LocalEditDataConverter,
        LocalEditReporter,
    ]);

    // 本地编辑业务实现
    const LocalEditManager = createService<ILocalEditManager>().dependsOn([
        SlideDataServices.Infra.Logger,
        LocalEditContext,
        LocalEditEvents,
        LocalEditService,
        SlideDataServices.ContentStatusManager,
        SlideDataServices.UI.Snackbar,
        DocVerifierManager,
    ]);

    const EmbeddedFontManager = createService<{}>().dependsOn([
        SlideDataServices.Infra.Logger,
        SlideDataServices.SlideAppService,
    ]);

    return {
        UI,

        LocalEditContext,
        LocalEditDataConverter,
        LocalEditEvents,
        LocalEditNoticeManager,
        LocalEditReporter,
        LocalEditService,
        LocalEditManager,

        EmbeddedFontManager,
        DocVerifierManager,
    };
});
